
// Utility function to format amenity names for display
export const formatAmenityName = (amenity: string): string => {
  const formatMap: Record<string, string> = {
    'walk_in_closet': 'Walk-in Closet',
    'washer_dryer': 'Washer/Dryer',
    'air_conditioning': 'Air Conditioning',
    'stainless_steel_appliances': 'Stainless Steel Appliances',
    'granite_countertops': 'Granite Countertops',
    'hardwood_floors': 'Hardwood Floors',
    'in_unit_laundry': 'In-Unit Laundry',
    'fitness_center': 'Fitness Center',
    'swimming_pool': 'Swimming Pool',
    'pet_friendly': 'Pet Friendly',
    'parking_included': 'Parking Included',
    'balcony_patio': 'Balcony/Patio',
    'dishwasher': 'Dishwasher',
    'microwave': 'Microwave',
    'refrigerator': 'Refrigerator',
    'cable_ready': 'Cable Ready',
    'high_speed_internet': 'High Speed Internet'
  };

  return formatMap[amenity] || amenity.split('_').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
};

// Get the database value from display name
export const getAmenityValue = (displayName: string): string => {
  const reverseMap: Record<string, string> = {
    'Walk-in Closet': 'walk_in_closet',
    'Washer/Dryer': 'washer_dryer',
    'Air Conditioning': 'air_conditioning',
    'Stainless Steel Appliances': 'stainless_steel_appliances',
    'Granite Countertops': 'granite_countertops',
    'Hardwood Floors': 'hardwood_floors',
    'In-Unit Laundry': 'in_unit_laundry',
    'Fitness Center': 'fitness_center',
    'Swimming Pool': 'swimming_pool',
    'Pet Friendly': 'pet_friendly',
    'Parking Included': 'parking_included',
    'Balcony/Patio': 'balcony_patio',
    'Dishwasher': 'dishwasher',
    'Microwave': 'microwave',
    'Refrigerator': 'refrigerator',
    'Cable Ready': 'cable_ready',
    'High Speed Internet': 'high_speed_internet'
  };

  return reverseMap[displayName] || displayName.toLowerCase().replace(/\s+/g, '_');
};
